/**
 * Layout.js
 *
 * Route wrapper for the public "share project" feature. Keeps routing
 * concerns minimal — all UI/logic lives in src/features/share-project.
 */
import React from 'react';
import { ShareProjectPage } from '@/features/share-project';

export default function Layout() {
  return <ShareProjectPage />;
}
